export default "__VITE_ASSET__DlTUSM77__"